import React, { useState, useEffect, Suspense, lazy, useRef } from "react";
import { useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Select from "react-select";

import DateRangePicker from "../DatePickers/DateRangePicker/DateRangePicker";
import EventsSortingTable from "../EventsSortingTable";
import LeftFilterBox from "../LeftFilterBox/LeftFilterBox";
import DateTimePicker from "../DatePickers/DateTimePicker/DateTimePicker";
import EventAnalysisAPI from "../../api/EventsAnalysisApi";

import Dropdown from "react-dropdown";
import Cookies from "js-cookie";
import ReactLoading from "react-loading";

const EventsCapturePlot = lazy(() => import("../plots/EventsCapturePlot"));
const CorrelatingEventTable = lazy(() => import("../plots/CorrelatingEventsTabel"));
const EventsTrendingPlot = lazy(() => import("../plots/EventsTrendingPlot"));
const SELTrendingPlot = lazy(() => import("../plots/SELTrendingPlot"));

const freqCalculationOptions = [
    {
        label: "None",
        value: "None",
    },
    {
        label: "Power Factor",
        value: "pf_raw",
    },
];

const formatDate = (date) => {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
};

const formatDateTime = (date) => {
    return (
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.toTimeString().split(" ")[0]
    );
};

export default function EventsAnalysisTab() {
    const token = Cookies.get("Session");

    // extarcting from redux slice
    const { selectedFacility, selectedEquipment, equipmentTimezone, showSELMenu, selectedCustomer, equipmentsList } =
        useSelector((state) => state.equipmentsPortfolio);
    const selectedVoltageType = useSelector((state) => state.voltageType.selectedVoltageType);
    const { earlyAccess, mobileUnitAdmin } = useSelector((state) => state.user);
    const customer = useSelector((state) => state.equipmentsPortfolio.customerList[0].label);

    const [activeTabKey, setActiveTabKey] = useState("Events Capture");

    const [plotOrder, setPlotOrder] = useState({
        eventsCapture: 1,
        correlatingEvents: 2,
        eventsTrending: 3,
        selTrending: 4,
    });

    // Events Sorting Table Hook
    const [eventSortingTableData, setEventsSortingTableData] = useState({ columns: [], rows: [] });

    // Events Capture Tab Hooks
    const plotEvent = useSelector((state) => state.plotEvent);
    useEffect(() => {
        if (plotEvent.time) {
            setActiveTabKey("Events Capture");
        }
    }, [plotEvent]);

    const [eventCaptureStartDate, setEventCaptureStartDate] = useState(
        new Date(new Date().valueOf() - 1000 * 60 * 60 * 24 * 7),
    );
    const [eventCaptureEndDate, setEventCaptureEndDate] = useState(new Date());

    const [eventFileList, setEventFileList] = useState([]);
    const [selectEventFile, setSelectdEventFile] = useState();
    const [eventCapturePlotData, setEventCapturePlotData] = useState({
        va: "",
        vb: "",
        vc: "",
        ia: "",
        ib: "",
        ic: "",
        np_I_peak: { x: "", y: "" },
        time: "",
        title: "",
    });
    const [selTableData, setSELTableData] = useState({});

    const [eventsCaptureAlert, setEventsCaptureAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    const [selectedFreqCalculationType, setSelectedFreqCalculationType] = useState(freqCalculationOptions[0]);

    const displayLLCurrent =
        selectedFreqCalculationType.value === "pf_raw" &&
        selectedVoltageType.value === "L-L" &&
        selectedEquipment?.node_sn != 21348;

    const [isEventsCapturePlotLoading, setIsEventsCapturePlotLoading] = useState(false);
    const [showEventsCapturePlot, setShowEventsCapturePlot] = useState(false);
    const [eventCapturePlotMetaData, setEventCapturePlotMetaData] = useState({
        equipment_name: "",
        eqTypeSub: "---",
        facility_name: "",
        esa_timestamp: "",
        analysisType: "None",
        Np_I_peak: "",
    });

    const [compareFlag, setCompareFlag] = useState(false);
    const [compareType, setCompareType] = useState("time");
    const [fileOne, setFileOne] = useState();
    const [fileTwo, setFileTwo] = useState();

    const [fileOneEquipment, setFileOneEquipment] = useState();
    const [fileTwoEquipment, setFileTwoEquipment] = useState();
    const eventTimeIdx1 = useRef();
    const eventTimeIdx2 = useRef();

    const hasCompareEvents = customer == "Factory Mutual Insurance Company" && earlyAccess == true;

    useEffect(() => {
        setEventCapturePlotMetaData((prevData) => {
            return {
                ...prevData,
                compareType: compareType,
            };
        });
    }, [compareType]);

    useEffect(() => {
        const eventFile = eventFileList.find((file) => file.label.includes(plotEvent.time));

        if (eventFile) {
            // setTabData((prevState) => {
            //     return {
            //         ...prevState,
            //         selectedEventFile: eventFile,
            //         showPlotOnDoubleClick: true,
            //     };
            // });

            setSelectdEventFile(eventFile);

            setShowEventsCapturePlot(true);
            setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
            setIsEventsCapturePlotLoading(true);
            setEventCapturePlotMetaData({
                selectedEquipment: selectedEquipment,
                selectedESA: eventFile,
                analysisType: selectedFreqCalculationType.value,
                selectedVoltageType: selectedVoltageType,
                displayLLCurrent: displayLLCurrent,
            });
            setEventCapturePlotData({
                time: [],
                current: {
                    Ia: [],
                    Ib: [],
                    Ic: [],
                },
                voltage_ln: {
                    Va: [],
                    Vb: [],
                    Vc: [],
                },
                voltage_ll: {
                    Vab: [],
                    Vbc: [],
                    Vca: [],
                },
                analysis: {},
            });
            setSELTableData({});

            EventAnalysisAPI.getEventsPlotData(
                token,
                selectedEquipment.location_node_id,
                eventFile.value,
                selectedEquipment.product_type,
                selectedFreqCalculationType.value,
                selectedVoltageType.value,
                displayLLCurrent,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "primary",
                            text: "No Data Found",
                            show: true,
                        });
                    } else {
                        setEventCapturePlotData(response.data.content.plot_data);
                        setSELTableData(response.data.content.meta);
                        setIsEventsCapturePlotLoading(false);
                        setShowEventsCapturePlot(true);
                        setPlotOrder({
                            eventsCapture: 1,
                            correlatingEvents: 2,
                            eventsTrending: 3,
                            selTrending: 4,
                        });
                    }
                })
                .catch((err) => {
                    setIsEventsCapturePlotLoading(false);
                    setShowEventsCapturePlot(false);
                    console.log(err);
                });
        } else {
            setEventsCaptureAlert({
                color: "primary",
                text: "No Event Found",
                show: true,
            });
        }
    }, [plotEvent]);

    // Correlating Event Tab Hooks
    const [isCorrelatingTableLoading, setIsCorrelatingTableLoading] = useState(false);

    const [correlatingAlert, setCorrelatingAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    const [correlatingEventsDateTime, setCorrelatingEventsDateTime] = useState(new Date());

    const [correlatingEventsSeconds, setCorrelatingEventsSeconds] = useState(2);
    const [isCorrelatingDurationInValid, setIsCorrelatingDurationInValid] = useState(false);
    const [showCorrelatingTable, setShowCorrelatingTable] = useState(false);
    useEffect(() => {
        setCorrelatingAlert({ ...correlatingAlert, show: false });
    }, [selectedCustomer, selectedFacility, selectedEquipment]);

    const [CorrelatingTabData, setCorrelatingTabData] = useState({
        tableData: { rows: "", columns: "" },
        plotMetaData: "",
        showPlot: false,
        isCorrelatingPlotLoading: false,
        currentSelectedTimeOnEventsCaptureTab: 0,
    });

    useEffect(() => {
        if (selectEventFile) {
            const inputDateString = selectEventFile.label;
            const parts = inputDateString.split(/[- :]/);
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[2], 10);
            const hour = parseInt(parts[3], 10);
            const minute = parseInt(parts[4], 10);
            const second = parseInt(parts[5], 10);
            const outputDate = new Date(year, month, day, hour, minute, second);
            setCorrelatingEventsDateTime(outputDate);
            return;
        }
    }, [selectEventFile]);

    // Events Trending Tab Hooks
    const [eventsTrendingStartDate, setEventsTrendingStartDate] = useState(
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
    );
    const [eventsTrendingEndDate, setEventsTrendingEndDate] = useState(new Date());
    const [eventsTrendingPlotData, setEventsTrendingPlotData] = useState({
        current_rise: [],
        current_fall: [],
        voltage_rise: [],
        voltage_fall: [],
        start: [],
        stop: [],
        start_d: [],
        stop_u: [],
        day: [],
        Title: [],
    });

    const [isEventsTrendingPlotLoading, setIsEventsTrendingPlotLoading] = useState(false);
    const [showEventsTrendingPlot, setShowEventsTrendingPlot] = useState(false);

    const [eventsTrendingAlert, setEventsTrendingAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    const [eventsTrendingPlotMetaData, setEventsTrendingPlotMetaData] = useState({
        equipment_name: "",
        facility_name: "",
        startDate: "",
        endDate: "",
    });
    const [selTrendingPlotData, setSelTrendingPlotData] = useState({
        plotData: [],
        showPlot: false,
        plotMetaData: [],
        selTableData: {},
    });

    const [additionalNodesFlag, setAdditionalNodesFlag] = useState(false);
    const [selectedNodes, setSelectedNodes] = useState([]);

    useEffect(() => {
        if (selectedEquipment == null || !showSELMenu) {
            setAdditionalNodesFlag(false);
            setSelectedNodes([]);
        } else if (!additionalNodesFlag) {
            setSelectedNodes([selectedEquipment]);
        } else if (selectedNodes.includes(selectedEquipment)) {
            const idx = selectedNodes.indexOf(selectedEquipment);
            setSelectedNodes([selectedEquipment, ...selectedNodes.slice(0, idx), ...selectedNodes.slice(idx + 1, 9)]);
        } else {
            setSelectedNodes([selectedEquipment, ...selectedNodes.slice(0, 9)]);
        }
    }, [selectedEquipment, additionalNodesFlag]);

    const updateSelectedNodes = (val) => {
        if (val.length > 10) {
            setEventsTrendingAlert({
                color: "primary",
                text: "No More Than 10 Nodes May Be Selected at Once",
                show: true,
            });
            return;
        }
        if (!val.includes(selectedEquipment)) {
            setEventsTrendingAlert({
                color: "primary",
                text: "Cannot Remove Selected Equipment From Additional Nodes List",
                show: true,
            });
            return;
        }
        setSelectedNodes(val);
    };

    useEffect(() => {
        if (selectedFacility) {
            setEventFileList([]);
            setSelectdEventFile();
            setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
            setCorrelatingAlert({ ...correlatingAlert, show: false });
            setEventsTrendingAlert({ ...eventsTrendingAlert, show: false });
            setEventsSortingTableData({ columns: [], rows: [] });
        }
    }, [selectedFacility]);

    useEffect(() => {
        if (selectedEquipment) {
            setEventFileList([]);
            setSelectdEventFile();
            setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
            setCorrelatingAlert({ ...correlatingAlert, show: false });
            setEventsTrendingAlert({ ...eventsTrendingAlert, show: false });
            setEventsSortingTableData({ columns: [], rows: [] });

            EventAnalysisAPI.getEventsList(
                token,
                selectedEquipment.value,
                selectedEquipment.label,
                formatDate(eventCaptureStartDate),
                formatDate(eventCaptureEndDate),
                equipmentTimezone.value,
                selectedEquipment.product_type,
                selectedVoltageType.value,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "danger",
                            text: "No Event Found",
                            show: true,
                        });
                    } else {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setEventsCaptureAlert({
                                color: "primary",
                                text: text,
                                show: true,
                            });
                        } else {
                            setEventFileList(response.data.content.list_data);
                            setEventsSortingTableData(response.data.content.table_data);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            if (selectedEquipment.product_type === "SEL") {
                if (activeTabKey !== "Events Capture" && activeTabKey !== "Events Trending") {
                    setActiveTabKey("Events Capture");
                }
            }
        } else {
            setEventFileList([]);
            setEventsSortingTableData({ columns: [], rows: [] });
        }
    }, [selectedEquipment]);

    useEffect(() => {
        if (showEventsCapturePlot && selectEventFile) {
            onEventCapturePlotButtonClick();
        }
        if (selectedEquipment) {
            EventAnalysisAPI.getEventsList(
                token,
                selectedEquipment.value,
                selectedEquipment.label,
                formatDate(eventCaptureStartDate),
                formatDate(eventCaptureEndDate),
                equipmentTimezone.value,
                selectedEquipment.product_type,
                selectedVoltageType.value,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "danger",
                            text: "No Event Found",
                            show: true,
                        });
                    } else {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setEventsCaptureAlert({
                                color: "primary",
                                text: text,
                                show: true,
                            });
                        } else {
                            setEventFileList(response.data.content.list_data);
                            setEventsSortingTableData(response.data.content.table_data);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [selectedVoltageType]);

    {
        /************************************ Event Capture Tab fuctions **************************************************************/
    }

    useEffect(() => {
        setEventsCaptureAlert({
            color: "danger",
            text: "",
            show: false,
        });
        if (selectedEquipment) {
            setEventFileList([]);
            setEventsSortingTableData({ columns: [], rows: [] });

            EventAnalysisAPI.getEventsList(
                token,
                selectedEquipment.value,
                selectedEquipment.label,
                formatDate(eventCaptureStartDate),
                formatDate(eventCaptureEndDate),
                equipmentTimezone.value,
                selectedEquipment.product_type,
                selectedVoltageType.value,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "danger",
                            text: "No Event Found",
                            show: true,
                        });
                    } else {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setEventsCaptureAlert({
                                color: "primary",
                                text: text,
                                show: true,
                            });
                        } else {
                            setEventFileList(response.data.content.list_data);
                            setEventsSortingTableData(response.data.content.table_data);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [equipmentTimezone, selectedVoltageType]);

    const onEventCaptureStartDateChange = (date) => {
        setEventFileList([]);
        setSelectdEventFile();
        setEventCaptureStartDate(date);
        setEventsSortingTableData({ columns: [], rows: [] });
        setEventsCaptureAlert({
            color: "danger",
            text: "",
            show: false,
        });

        if (selectedEquipment) {
            EventAnalysisAPI.getEventsList(
                token,
                selectedEquipment.value,
                selectedEquipment.label,
                formatDate(date),
                formatDate(eventCaptureEndDate),
                equipmentTimezone.value,
                selectedEquipment.product_type,
                selectedVoltageType.value,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "danger",
                            text: "No Event Found",
                            show: true,
                        });
                    } else {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setEventsCaptureAlert({
                                color: "primary",
                                text: text,
                                show: true,
                            });
                        } else {
                            if (response.data.content == null) {
                                const text = response.data.info;
                                setEventsCaptureAlert({
                                    color: "primary",
                                    text: text,
                                    show: true,
                                });
                            } else {
                                setEventFileList(response.data.content.list_data);
                                setEventsSortingTableData(response.data.content.table_data);
                            }
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const onEventCaptureEndDateChange = (date) => {
        setEventFileList([]);
        setSelectdEventFile();
        setEventsSortingTableData({ columns: [], rows: [] });

        setEventsCaptureAlert({
            color: "danger",
            text: "No Event Found",
            show: false,
        });
        setEventCaptureEndDate(date);
        if (selectedEquipment) {
            EventAnalysisAPI.getEventsList(
                token,
                selectedEquipment.value,
                selectedEquipment.label,
                formatDate(eventCaptureStartDate),
                formatDate(date),
                equipmentTimezone.value,
                selectedEquipment.product_type,
                selectedVoltageType.value,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "danger",
                            text: "No Event Found",
                            show: true,
                        });
                    } else {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setEventsCaptureAlert({
                                color: "primary",
                                text: text,
                                show: true,
                            });
                        } else {
                            setEventFileList(response.data.content.list_data);
                            setEventsSortingTableData(response.data.content.table_data);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const onEventCapturePlotButtonClick = () => {
        if (compareFlag && hasCompareEvents) {
            if (!fileOne || !fileTwo) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select both files",
                });
            } else {
                setShowEventsCapturePlot(true);
                setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
                setIsEventsCapturePlotLoading(true);
                setEventCapturePlotMetaData({
                    selectedEquipment: selectedEquipment,
                    selectedESA: selectEventFile,
                    analysisType: selectedFreqCalculationType.value,
                    selectedVoltageType: selectedVoltageType,
                    displayLLCurrent: displayLLCurrent,
                    eventTimeIdx: eventTimeIdx1.current,
                    compareFlag: compareFlag,
                    compareType: compareType,
                    fileOne: fileOne,
                    fileTwo: fileTwo,
                    fileOneEquipment: fileOneEquipment,
                    fileTwoEquipment: fileTwoEquipment,
                    eventTimeIdxTwo: eventTimeIdx2.current,
                });
                setEventCapturePlotData({
                    time: [],
                    current: {
                        Ia: [],
                        Ib: [],
                        Ic: [],
                    },
                    voltage_ln: {
                        Va: [],
                        Vb: [],
                        Vc: [],
                    },
                    voltage_ll: {
                        Vab: [],
                        Vbc: [],
                        Vca: [],
                    },
                    analysis: {},
                });
                setSELTableData({});

                const firstFile = EventAnalysisAPI.getEventsPlotData(
                    token,
                    fileOneEquipment.location_node_id,
                    fileOne.value,
                    fileOneEquipment.product_type,
                    selectedFreqCalculationType.value,
                    selectedVoltageType.value,
                    displayLLCurrent,
                    fileOne?.label.split(" - ").slice(0, -1).join(""),
                    eventTimeIdx1.current,
                );
                const secondFile = EventAnalysisAPI.getEventsPlotData(
                    token,
                    fileTwoEquipment.location_node_id,
                    fileTwo.value,
                    fileTwoEquipment.product_type,
                    selectedFreqCalculationType.value,
                    selectedVoltageType.value,
                    displayLLCurrent,
                    fileTwo?.label.split(" - ").slice(0, -1).join(""),
                    eventTimeIdx2.current,
                );
                Promise.all([firstFile, secondFile])
                    .then(([resp1, resp2]) => {
                        if (resp1.status === 200 && resp2.status === 200) {
                            // Remove unused channels for eq_type_sub v1
                            if (fileOneEquipment.eq_type_sub === "v1") {
                                resp1.data.content.plot_data.V2.x = [];
                                resp1.data.content.plot_data.V2.y = [];

                                resp1.data.content.plot_data.V3.x = [];
                                resp1.data.content.plot_data.V3.y = [];
                            }
                            // Remove unused channels for eq_type_sub v1
                            if (fileTwoEquipment.eq_type_sub === "v1") {
                                resp2.data.content.plot_data.V2.x = [];
                                resp2.data.content.plot_data.V2.y = [];

                                resp2.data.content.plot_data.V3.x = [];
                                resp2.data.content.plot_data.V3.y = [];
                            }

                            const data = {
                                plotData1: resp1.data.content.plot_data,
                                plotData2: resp2.data.content.plot_data,
                            };
                            setEventCapturePlotData(data);
                            setShowEventsCapturePlot(true);
                        }
                        setIsEventsCapturePlotLoading(false);
                    })
                    .catch((err) => {
                        setIsEventsCapturePlotLoading(false);
                        console.log(err);
                    });
            }
        } else {
            if (!selectedFacility) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select a Facility",
                });
            } else if (!selectedEquipment) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select an Equipment ",
                });
            } else if (!selectEventFile) {
                setEventsCaptureAlert({
                    color: "primary",
                    text: "Select Event File",
                    show: true,
                });
            } else {
                setShowEventsCapturePlot(true);
                setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
                setIsEventsCapturePlotLoading(true);
                setEventCapturePlotMetaData({
                    selectedEquipment: selectedEquipment,
                    selectedESA: selectEventFile,
                    analysisType: selectedFreqCalculationType.value,
                    selectedVoltageType: selectedVoltageType,
                    displayLLCurrent: displayLLCurrent,
                });
                setEventCapturePlotData({
                    time: [],
                    current: {
                        Ia: [],
                        Ib: [],
                        Ic: [],
                    },
                    voltage_ln: {
                        Va: [],
                        Vb: [],
                        Vc: [],
                    },
                    voltage_ll: {
                        Vab: [],
                        Vbc: [],
                        Vca: [],
                    },
                    analysis: {},
                });
                setSELTableData({});

                EventAnalysisAPI.getEventsPlotData(
                    token,
                    selectedEquipment.location_node_id,
                    selectEventFile.value,
                    selectedEquipment.product_type,
                    selectedFreqCalculationType.value,
                    selectedVoltageType.value,
                    displayLLCurrent,
                )
                    .then((response) => {
                        if (response.status === 204) {
                            setEventsCaptureAlert({
                                color: "primary",
                                text: "No Data Found",
                                show: true,
                            });
                        } else {
                            setEventCapturePlotData(response.data.content.plot_data);
                            setSELTableData(response.data.content.meta);
                            setIsEventsCapturePlotLoading(false);
                            setShowEventsCapturePlot(true);
                            setPlotOrder({
                                eventsCapture: 1,
                                correlatingEvents: 2,
                                eventsTrending: 3,
                                selTrending: 4,
                            });
                        }
                    })
                    .catch((err) => {
                        setIsEventsCapturePlotLoading(false);
                        setShowEventsCapturePlot(false);
                        console.log(err);
                    });
            }
        }
    };

    {
        /************************************ Correlating Tab fuctions **************************************************************/
    }
    //Close tab
    useEffect(() => {
        if (!CorrelatingTabData.showPlot) {
            setShowCorrelatingTable(false);
        }
    }, [CorrelatingTabData]);

    const onCorrelatingDateTimeChange = (date) => {
        setCorrelatingEventsDateTime(date);
    };

    const onCorrelatingSecondsChange = (val) => {
        setCorrelatingEventsSeconds(val);
        if (val <= 0) {
            setIsCorrelatingDurationInValid(true);
        } else {
            setIsCorrelatingDurationInValid(false);
        }
    };
    const onCorrelatingPlotButtonClick = () => {
        // Hiding the banner
        setCorrelatingAlert({
            text: "No Events Found",
            show: false,
            color: "primary",
        });
        // Hiding the correlating Table
        setShowCorrelatingTable(false);

        if (!selectedFacility) {
            setCorrelatingAlert({
                color: "primary",
                show: true,
                text: "Select a Facility",
            });
        } else {
            setIsCorrelatingTableLoading(true);
            setShowCorrelatingTable(true);
            setCorrelatingTabData((prevState) => {
                return {
                    ...prevState,
                    tabelData: { rows: [], columns: [] },
                    tableData: { columns: [], rows: [], metadata: {} },
                    tableMetaData: { selectedFacility: selectedFacility },
                    showTable: true,
                };
            });

            EventAnalysisAPI.get_correlating_events_list(
                token,
                selectedFacility.facility_id,
                formatDateTime(correlatingEventsDateTime),
                correlatingEventsSeconds,
                equipmentTimezone.value,
            )
                .then((response) => {
                    if (response.status === 204) {
                        setCorrelatingAlert({
                            text: "No Events Found",
                            show: true,
                            color: "primary",
                        });
                        setIsCorrelatingTableLoading(false);
                        setCorrelatingTabData((prevState) => {
                            return {
                                ...prevState,
                                showTable: false,
                                isCorrelatingTableLoading: false,
                            };
                        });
                    } else {
                        setCorrelatingTabData((prevState) => {
                            return {
                                ...prevState,
                                tableData: response.data.content,
                                isCorrelatingTableLoading: false,
                                showTable: true,
                            };
                        });
                        setIsCorrelatingTableLoading(false);
                        setShowCorrelatingTable(true);
                    }
                })
                .catch((err) => {
                    setIsCorrelatingTableLoading(false);
                    setShowCorrelatingTable(false);
                    setCorrelatingTabData((prevState) => {
                        return {
                            ...prevState,
                            isCorrelatingTableLoading: false,
                            showTable: false,
                        };
                    });
                    console.log(err);
                });
        }
    };
    {
        /************************************ Events Trending Tab fuctions **************************************************************/
    }

    const onEventsTrendingStartDateChange = (date) => {
        setEventsTrendingStartDate(date);
    };

    const onEventsTrendingEndDateChange = (date) => {
        setEventsTrendingEndDate(date);
    };

    const onEventsTrendingPlotButtonClick = () => {
        if (!selectedFacility) {
            setEventsTrendingAlert({
                color: "primary",
                show: true,
                text: "Select a Facility",
            });
        } else if (!selectedEquipment) {
            setEventsTrendingAlert({
                color: "primary",
                show: true,
                text: "Select an Equipment ",
            });
        } else {
            setEventsTrendingAlert({ ...eventsTrendingAlert, show: false });
            setIsEventsTrendingPlotLoading(true);
            setEventsTrendingPlotMetaData({
                selectedEquipment: selectedEquipment,
                equipmentName: selectedEquipment.label,
                facilityName: selectedFacility.label,
                startDate: formatDate(eventsTrendingStartDate),
                endDate: formatDate(eventsTrendingEndDate),
                additionalNodesFlag: additionalNodesFlag,
                selectedNodes: selectedNodes,
            });

            if (selectedEquipment.product_type === "SEL") {
                setSelTrendingPlotData((prevState) => {
                    return {
                        ...prevState,
                        showPlot: true,
                        plotMetaData: {
                            selectedEquipment: selectedEquipment,
                            equipmentName: selectedEquipment.label,
                            facilityName: selectedFacility.label,
                            startDate: formatDate(eventsTrendingStartDate),
                            endDate: formatDate(eventsTrendingEndDate),
                            additionalNodesFlag: additionalNodesFlag,
                            selectedNodes: selectedNodes,
                        },
                        isPlotLoading: true,
                    };
                });
                EventAnalysisAPI.getSELAlarmsTrip(
                    token,
                    selectedEquipment.value,
                    formatDate(eventsTrendingStartDate),
                    formatDate(eventsTrendingEndDate),
                    equipmentTimezone.value,
                    selectedNodes,
                )
                    .then((response) => {
                        setSelTrendingPlotData((prevState) => {
                            return {
                                ...prevState,
                                isPlotLoading: false,
                            };
                        });

                        if (response.status === 204) {
                            setEventsTrendingAlert({
                                color: "primary",
                                show: true,
                                text: "No Data Found",
                            });
                        } else {
                            setSelTrendingPlotData((prevState) => {
                                return {
                                    ...prevState,
                                    plotData: response.data.content.plot_data,
                                    showPlot: true,
                                };
                            });
                        }
                        setIsEventsTrendingPlotLoading(false);
                        setPlotOrder({
                            eventsCapture: 4,
                            correlatingEvents: 2,
                            eventsTrending: 2,
                            selTrending: 1,
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                        setIsEventsTrendingPlotLoading(false);
                        setSelTrendingPlotData((prevState) => {
                            return {
                                ...prevState,
                                isPlotLoading: false,
                            };
                        });
                    });
            } else {
                setShowEventsTrendingPlot(true);
                EventAnalysisAPI.getEventsTrendingPlotData(
                    token,
                    selectedEquipment.value,
                    formatDate(eventsTrendingStartDate),
                    formatDate(eventsTrendingEndDate),
                    equipmentTimezone.value,
                    [],
                )
                    .then((response) => {
                        if (response.status === 204) {
                            setEventsTrendingAlert({
                                color: "primary",
                                show: true,
                                text: "No Data Found",
                            });
                        } else {
                            setEventsTrendingPlotData(response.data.content.plot_data.events_trending);
                            setIsEventsTrendingPlotLoading(false);
                            setPlotOrder({
                                eventsCapture: 3,
                                correlatingEvents: 2,
                                eventsTrending: 1,
                                selTrending: 4,
                            });
                        }
                    })
                    .catch((err) => {
                        setIsEventsTrendingPlotLoading(false);
                        setShowEventsTrendingPlot(false);
                        console.log(err);
                    });
            }
        }
    };

    {
        /* Real time events */
    }
    const hasRTEvents = customer === "Factory Mutual Insurance Company" || mobileUnitAdmin;
    const [tag, setTag] = useState("");
    const [duration, setDuration] = useState(10);

    const [realtimeAlert, setRealtimeAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });

    const isDurationValid = (value) => {
        if (value == null || value === "") {
            return true; // Allow empty input for duration
        }

        // Check if the value is a number and within the range of -60 to 60
        const numValue = parseInt(value, 10);
        return !isNaN(numValue) && numValue >= -60 && numValue <= 60 && numValue !== 0;
    };

    const isTagValid = (value) => {
        const val = String(value);

        if (val.length === 0) return true; // Allow empty input for tag

        const tagRegex = /^[a-zA-Z0-9\_\- ]+$/; // Only alphanumeric characters and underscores

        return tagRegex.test(val);
    };

    const onDurationChange = (event) => {
        const value = event.target.value;

        const durationRegex = /^-?\d*$/; // Allow only numbers, including negative numbers
        if (!durationRegex.test(value)) {
            return; // Ignore invalid input
        }
        setDuration(value);
    };

    const onTagChange = (event) => {
        const value = String(event.target.value);
        if (isTagValid(value)) {
            setTag(value.replace(" ", "_").slice(0, 30));
        }
    };

    const onPlotButtonClick = () => {
        if (!selectedFacility) {
            setRealtimeAlert({
                color: "primary",
                show: true,
                text: "Select a Facility",
            });
        } else if (!selectedEquipment) {
            setRealtimeAlert({
                color: "primary",
                show: true,
                text: "Select an Equipment ",
            });
        } else if (!isDurationValid(duration)) {
            setRealtimeAlert({
                color: "danger",
                show: true,
                text: "Enter a nonzero duration between -60 and 60 seconds",
            });
        } else {
            setRealtimeAlert({ ...realtimeAlert, show: false });

            setShowEventsCapturePlot(true);
            setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
            setIsEventsCapturePlotLoading(true);
            setEventCapturePlotMetaData({
                selectedEquipment: selectedEquipment,
                selectedESA: {},
                analysisType: null,
                selectedVoltageType: selectedVoltageType,
                displayLLCurrent: false,
            });

            setEventCapturePlotData({
                time: [],
                current: {
                    Ia: [],
                    Ib: [],
                    Ic: [],
                },
                voltage_ln: {
                    Va: [],
                    Vb: [],
                    Vc: [],
                },
                voltage_ll: {
                    Vab: [],
                    Vbc: [],
                    Vca: [],
                },
                analysis: {},
            });
            setSELTableData({});

            if (duration < 0) {
                getRealtimeEvent(
                    selectedEquipment.location_node_id,
                    tag,
                    Math.abs(duration),
                    selectedVoltageType.value,
                    equipmentTimezone.value,
                );
            } else {
                setTimeout(() => {
                    getRealtimeEvent(
                        selectedEquipment.location_node_id,
                        tag,
                        duration,
                        selectedVoltageType.value,
                        equipmentTimezone.value,
                    );
                }, duration * 1000);
            }
        }
    };

    const getRealtimeEvent = (location_node_id, tag, duration, v_type, timezone) => {
        EventAnalysisAPI.getRealtimeEvent(token, location_node_id, tag, duration, v_type, timezone)
            .then((response) => {
                if (response.status === 204) {
                    setEventsCaptureAlert({
                        color: "primary",
                        text: "No Data Found",
                        show: true,
                    });
                } else {
                    setEventCapturePlotData(response.data.content.plot_data);
                    setEventCapturePlotMetaData((prev) => {
                        return {
                            ...prev,
                            selectedESA: { label: response.data.content.timestamp },
                        };
                    });
                    setSELTableData(response.data.content.meta);
                    setIsEventsCapturePlotLoading(false);
                    setShowEventsCapturePlot(true);
                    setPlotOrder({
                        eventsCapture: 1,
                        correlatingEvents: 2,
                        eventsTrending: 3,
                        selTrending: 4,
                    });
                }
            })
            .catch((err) => {
                setIsEventsCapturePlotLoading(false);
                setShowEventsCapturePlot(false);
                console.log(err);
            });
    };

    const handleFileButtonClick = (fileNum, action) => {
        const file = action == "remove" ? null : selectEventFile;
        const eq = action == "remove" || !file ? null : selectedEquipment;
        if (action == "add" && !selectEventFile) {
            setEventsCaptureAlert({
                color: "primary",
                text: "Select a file",
                show: true,
            });
        }
        if (fileNum == 1) {
            setFileOne(file);
            setFileOneEquipment(eq);
            eventTimeIdx1.current = eventSortingTableData.rows.filter(
                (row) => row.s3_bucket_key_pair == file?.value,
            )[0]?.zero_sample;
        } else {
            setFileTwo(file);
            setFileTwoEquipment(eq);
            eventTimeIdx2.current = eventSortingTableData.rows.filter(
                (row) => row.s3_bucket_key_pair == file?.value,
            )[0]?.zero_sample;
        }
    };

    return (
        <div>
            <Card>
                <Card.Body>
                    <Row className="mt-3">
                        {/************************************ Facility and Node Selection Column **************************************************************/}
                        <Col className="col-4">
                            <LeftFilterBox />
                        </Col>

                        {/********************************************************* Sub Menu Tabs ******************************************************************/}
                        <Col className="col-8 ">
                            <Card>
                                <Card.Body>
                                    <Tabs
                                        defaultActiveKey="Events Capture"
                                        activeKey={activeTabKey}
                                        variant="pills"
                                        onSelect={(tabName) => {
                                            setActiveTabKey(tabName);
                                        }}
                                    >
                                        {/******************************************** Events Capture Tab ********************************************************************/}
                                        <Tab eventKey="Events Capture" title="Events Capture">
                                            <Row>
                                                <Col>
                                                    <h2 className="margin-top-10">Events Capture</h2>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="event-data col-7">
                                                    <label>Select Date Range:</label>
                                                    <br></br>
                                                    <DateRangePicker
                                                        startDate={eventCaptureStartDate}
                                                        endDate={eventCaptureEndDate}
                                                        onStartDateChange={onEventCaptureStartDateChange}
                                                        onEndDateChange={onEventCaptureEndDateChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <br />
                                            <Row>
                                                <Col className="col-7">
                                                    {showSELMenu ? <br></br> : null}
                                                    <label>Select Event File:</label>
                                                    <br></br>
                                                    <Dropdown
                                                        options={eventFileList}
                                                        value={selectEventFile}
                                                        onChange={(value) => {
                                                            setEventsCaptureAlert({
                                                                color: "primary",
                                                                show: false,
                                                                text: "Select an Equipment ",
                                                            });
                                                            setSelectdEventFile(value);
                                                        }}
                                                    />
                                                    <br></br>
                                                </Col>
                                                <Col className={showSELMenu || !earlyAccess ? "col-5 d-none" : "col-5"}>
                                                    <label>Select Analysis Type:</label>
                                                    <br></br>
                                                    <Dropdown
                                                        options={freqCalculationOptions}
                                                        value={selectedFreqCalculationType}
                                                        onChange={(val) => setSelectedFreqCalculationType(val)}
                                                    />
                                                </Col>
                                            </Row>
                                            {hasCompareEvents && (
                                                <Row>
                                                    <Col>
                                                        <Form.Check
                                                            onChange={(event) => {
                                                                setCompareFlag(event.target.checked);
                                                            }}
                                                            type="checkbox"
                                                            label="Compare Events"
                                                            checked={compareFlag}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            {compareFlag && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group inline="true" style={{ paddingLeft: "1rem" }}>
                                                            <Form.Check
                                                                inline="true"
                                                                onChange={(event) => {
                                                                    setCompareType(event.target.value);
                                                                }}
                                                                type="radio"
                                                                label="Time Align"
                                                                value="time"
                                                                checked={compareType == "time"}
                                                            />
                                                            <Form.Check
                                                                inline="true"
                                                                onChange={(event) => {
                                                                    setCompareType(event.target.value);
                                                                }}
                                                                type="radio"
                                                                label="Stacked"
                                                                value="stacked"
                                                                checked={compareType == "stacked"}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            )}
                                            {compareFlag && (
                                                <>
                                                    <Row>
                                                        <Col className="col-6">
                                                            <Row>
                                                                <Col>
                                                                    <Row>
                                                                        <Col>
                                                                            File 1:{" "}
                                                                            {fileOneEquipment
                                                                                ? `SN:${fileOneEquipment.node_sn}`
                                                                                : ""}
                                                                        </Col>
                                                                        <Col
                                                                            style={{
                                                                                textAlign: "right",
                                                                            }}
                                                                        >
                                                                            <button
                                                                                style={{
                                                                                    background: "inherit",
                                                                                    border: "none",
                                                                                    padding: "0!important",
                                                                                    color: "#007bff",
                                                                                    "text-decoration": "underline",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() => {
                                                                                    const action = fileOne
                                                                                        ? "remove"
                                                                                        : "add";
                                                                                    handleFileButtonClick(1, action);
                                                                                }}
                                                                            >
                                                                                {fileOne ? "Remove" : "Add File"}
                                                                            </button>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <div
                                                                                style={{
                                                                                    position: "relative",
                                                                                    overflow: "hidden",
                                                                                    "background-color": "white",
                                                                                    border: "1px solid #ccc",
                                                                                    "border-radius": "2px",
                                                                                    "box-sizing": "border-box",
                                                                                    color: "#333",
                                                                                    cursor: "default",
                                                                                    outline: "none",
                                                                                    padding: "8px 52px 8px 10px",
                                                                                    transition: "all 200ms ease",
                                                                                }}
                                                                            >
                                                                                {fileOne ? fileOne.label : "File 1"}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col>
                                                            <Row>
                                                                <Col>
                                                                    <Row>
                                                                        <Col>
                                                                            File 2:{" "}
                                                                            {fileTwoEquipment
                                                                                ? `SN:${fileTwoEquipment.node_sn}`
                                                                                : ""}
                                                                        </Col>
                                                                        <Col
                                                                            style={{
                                                                                textAlign: "right",
                                                                            }}
                                                                        >
                                                                            <button
                                                                                style={{
                                                                                    background: "inherit",
                                                                                    border: "none",
                                                                                    padding: "0!important",
                                                                                    color: "#007bff",
                                                                                    "text-decoration": "underline",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() => {
                                                                                    const action = fileTwo
                                                                                        ? "remove"
                                                                                        : "add";
                                                                                    handleFileButtonClick(2, action);
                                                                                }}
                                                                            >
                                                                                {fileTwo ? "Remove" : "Add File"}
                                                                            </button>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col>
                                                                            <div
                                                                                style={{
                                                                                    position: "relative",
                                                                                    overflow: "hidden",
                                                                                    "background-color": "white",
                                                                                    border: "1px solid #ccc",
                                                                                    "border-radius": "2px",
                                                                                    "box-sizing": "border-box",
                                                                                    color: "#333",
                                                                                    cursor: "default",
                                                                                    outline: "none",
                                                                                    padding: "8px 52px 8px 10px",
                                                                                    transition: "all 200ms ease",
                                                                                }}
                                                                            >
                                                                                {fileTwo ? fileTwo.label : "File 2"}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                </>
                                            )}
                                            <Row>
                                                <Col className="col-2">
                                                    {isEventsCapturePlotLoading ? (
                                                        <ReactLoading
                                                            type="bars"
                                                            height={50}
                                                            width={50}
                                                            color="#007bff"
                                                        />
                                                    ) : (
                                                        <Button
                                                            variant="primary"
                                                            onClick={onEventCapturePlotButtonClick}
                                                            className="plot_button"
                                                        >
                                                            Plot
                                                        </Button>
                                                    )}
                                                </Col>
                                                <Col className="col-4 eventsAlert">
                                                    <Alert
                                                        variant={eventsCaptureAlert.color}
                                                        show={eventsCaptureAlert.show}
                                                        onClose={() =>
                                                            setEventsCaptureAlert({
                                                                ...eventsCaptureAlert,
                                                                show: false,
                                                            })
                                                        }
                                                        dismissible
                                                    >
                                                        {eventsCaptureAlert.text}
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        {/******************************************** Correlating Tab ********************************************************************/}
                                        <Tab
                                            eventKey="Correlating Events"
                                            title="Correlating Events"
                                            tabClassName={showSELMenu ? "d-none" : ""}
                                        >
                                            <Row>
                                                <Col>
                                                    <h2 className="margin-top-10">Correlating Events</h2>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-5 event-data oneSec-date-input">
                                                    <label>Select Time:</label>
                                                    <br></br>
                                                    <DateTimePicker
                                                        selectedDate={correlatingEventsDateTime}
                                                        onDateTimeChange={onCorrelatingDateTimeChange}
                                                    />
                                                </Col>
                                                <Col className="col-3">
                                                    <label>Tolerance in seconds:</label>
                                                    <br></br>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        max="400000"
                                                        value={correlatingEventsSeconds}
                                                        onChange={(newDuration) =>
                                                            onCorrelatingSecondsChange(newDuration.target.value)
                                                        }
                                                        isInvalid={isCorrelatingDurationInValid}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className="col-2">
                                                    <br></br>
                                                    {isCorrelatingTableLoading ? (
                                                        <ReactLoading
                                                            type="bars"
                                                            height={50}
                                                            width={50}
                                                            color="#007bff"
                                                        />
                                                    ) : (
                                                        <Button
                                                            variant="primary"
                                                            onClick={onCorrelatingPlotButtonClick}
                                                            className="plot_button"
                                                        >
                                                            Plot
                                                        </Button>
                                                    )}
                                                </Col>
                                                <Col className="col-4 eventsAlert">
                                                    <br />
                                                    <Alert
                                                        variant={correlatingAlert.color}
                                                        show={correlatingAlert.show}
                                                        onClose={() =>
                                                            setCorrelatingAlert({ ...correlatingAlert, show: false })
                                                        }
                                                        dismissible
                                                    >
                                                        {correlatingAlert.text}
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        </Tab>

                                        {/******************************************** Events Trending Tab *****************************************************************/}
                                        <Tab eventKey="Events Trending" title="Events Trending">
                                            <Row>
                                                <Col>
                                                    <h2 className="margin-top-10">Events Trending</h2>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="col-7 event-data">
                                                    <label>Select Date Range:</label>
                                                    <br></br>
                                                    <DateRangePicker
                                                        startDate={eventsTrendingStartDate}
                                                        endDate={eventsTrendingEndDate}
                                                        onStartDateChange={onEventsTrendingStartDateChange}
                                                        onEndDateChange={onEventsTrendingEndDateChange}
                                                    />
                                                </Col>
                                            </Row>
                                            <br />
                                            {showSELMenu && (
                                                <Row>
                                                    <Col>
                                                        <Form.Check
                                                            onChange={(event) => {
                                                                setAdditionalNodesFlag(event.target.checked);
                                                            }}
                                                            type="checkbox"
                                                            label="Select Additional Nodes"
                                                            checked={additionalNodesFlag}
                                                            disabled={!selectedEquipment}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                            {additionalNodesFlag && (
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <Select
                                                                options={equipmentsList}
                                                                isMulti
                                                                isClearable
                                                                defaultValue={selectedEquipment}
                                                                value={selectedNodes}
                                                                onChange={(val) => updateSelectedNodes(val)}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                            <Row>
                                                <Col className="col-2">
                                                    <br></br>
                                                    {isEventsTrendingPlotLoading ? (
                                                        <ReactLoading
                                                            type="bars"
                                                            height={50}
                                                            width={50}
                                                            color="#007bff"
                                                        />
                                                    ) : (
                                                        <Button
                                                            variant="primary"
                                                            onClick={onEventsTrendingPlotButtonClick}
                                                            className="plot_button"
                                                        >
                                                            Plot
                                                        </Button>
                                                    )}
                                                </Col>
                                                <Col className="col-4 eventsAlert">
                                                    <br />
                                                    <Alert
                                                        variant={eventsTrendingAlert.color}
                                                        show={eventsTrendingAlert.show}
                                                        onClose={() =>
                                                            setEventsTrendingAlert({
                                                                ...eventsTrendingAlert,
                                                                show: false,
                                                            })
                                                        }
                                                        dismissible
                                                    >
                                                        {eventsTrendingAlert.text}
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        </Tab>

                                        {/******************************************** Real-Time Events Tab *****************************************************************/}
                                        {hasRTEvents && (
                                            <Tab eventKey="Real-Time Events" title="Real-Time Events">
                                                <Row>
                                                    <Col>
                                                        <h2 className="margin-top-10">Real-time Events</h2>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="col-5">
                                                        <label>Input a label</label>
                                                        <br></br>
                                                        <Form.Control
                                                            type="string"
                                                            value={tag}
                                                            onChange={(newTag) => onTagChange(newTag)}
                                                            isInvalid={!isTagValid(tag)}
                                                            disabled={isEventsCapturePlotLoading}
                                                        />
                                                    </Col>
                                                    <Col className="col-3">
                                                        <label>Capture Length in Seconds:</label>
                                                        <br></br>
                                                        <Form.Control
                                                            value={duration}
                                                            onChange={(newDuration) => onDurationChange(newDuration)}
                                                            isInvalid={!isDurationValid(duration)}
                                                            placeholder="10"
                                                            disabled={isEventsCapturePlotLoading}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Enter a number between -60 and 60
                                                        </Form.Control.Feedback>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col className="col-2">
                                                        <br></br>
                                                        {isEventsCapturePlotLoading ? (
                                                            <ReactLoading
                                                                type="bars"
                                                                height={50}
                                                                width={50}
                                                                color="#007bff"
                                                            />
                                                        ) : (
                                                            <Button
                                                                variant="primary"
                                                                onClick={onPlotButtonClick}
                                                                className="plot_button"
                                                            >
                                                                Plot
                                                            </Button>
                                                        )}
                                                    </Col>
                                                    <Col className="col-5 eventsAlert">
                                                        <br />
                                                        <Alert
                                                            variant={realtimeAlert.color}
                                                            show={realtimeAlert.show}
                                                            onClose={() =>
                                                                setRealtimeAlert({ ...realtimeAlert, show: false })
                                                            }
                                                            dismissible
                                                        >
                                                            {realtimeAlert.text}
                                                        </Alert>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                        )}
                                    </Tabs>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br></br>
            <Suspense fallback={<div>Loading..</div>}>
                <EventsSortingTable
                    selectedEquipment={selectedEquipment}
                    setEventFile={setSelectdEventFile}
                    tableData={eventSortingTableData}
                />
                <br></br>
            </Suspense>
            <Suspense fallback={<div>Loading..</div>}>
                <Row>
                    <Col lg={{ order: plotOrder.eventsCapture, span: 12 }}>
                        {showEventsCapturePlot ? (
                            <EventsCapturePlot
                                plotData={eventCapturePlotData}
                                setEventCapturePlotData={setEventCapturePlotData}
                                showPlot={showEventsCapturePlot}
                                setShowPlot={setShowEventsCapturePlot}
                                plotMetaData={eventCapturePlotMetaData}
                                isPlotLoading={isEventsCapturePlotLoading}
                                selTableData={selTableData}
                            />
                        ) : null}
                    </Col>

                    <Col lg={{ order: plotOrder.correlatingEvents, span: 12 }}>
                        {showCorrelatingTable ? (
                            <CorrelatingEventTable tabData={CorrelatingTabData} setTabData={setCorrelatingTabData} />
                        ) : null}
                    </Col>

                    <Col lg={{ order: plotOrder.eventsTrending, span: 12 }}>
                        {showEventsTrendingPlot ? (
                            <EventsTrendingPlot
                                eventsTrendingPlotData={eventsTrendingPlotData}
                                setEventsTrendingPlotData={setEventsTrendingPlotData}
                                showPlot={showEventsTrendingPlot}
                                setShowPlot={setShowEventsTrendingPlot}
                                plotMetaData={eventsTrendingPlotMetaData}
                                isPlotLoading={isEventsTrendingPlotLoading}
                            />
                        ) : null}
                    </Col>

                    <Col lg={{ order: plotOrder.selTrending, span: 12 }}>
                        {selTrendingPlotData.showPlot ? (
                            <SELTrendingPlot tabData={selTrendingPlotData} setTabData={setSelTrendingPlotData} />
                        ) : null}
                    </Col>
                </Row>
            </Suspense>
        </div>
    );
}
